import React, { FC } from 'react'
import { cn } from 'shared/utils'
import Footer from 'components/Footer/Footer'
import { ConditionRender, ScrollToTopButton } from 'components/index'
import { LayoutProps } from './Layout.props'

const Layout: FC<LayoutProps> = ({
  children,
  hideFooter = false,
  hideScrollToTop = false,
  size = 'default',
  isGlobal = false
}) => {
  return (
    <div className={cn('page', { 'page--small': size === 'small', 'global-hub-page': isGlobal })}>
      {children}
      <ConditionRender condition={!hideFooter} component={<Footer />} />
      <ConditionRender
        condition={!hideScrollToTop}
        component={<ScrollToTopButton />}
      />
    </div>
  )
}

export default Layout
